import { Component } from '@angular/core';
import { ConfirmPopupModule } from 'primeng/confirmpopup';

@Component({
    selector: 'epx-confirm-popup',
    template: ' <p-confirmpopup key="epx-confirm-pop-up" styleClass="epx-confirm epx-confirm-popup"></p-confirmpopup> ',
    styleUrls: ['./epx-confirm-popup.component.scss'],
    imports: [ConfirmPopupModule]
})
export class EpxConfirmPopupComponent {}
